import React, { ChangeEvent, useContext, useEffect, useState } from "react";
import OwLabel from "../../../../shared/OwLabel/OwLabel";
import { SocketContext } from "../../../../../contexts/SocketContext";
import SupplierContext from "../../../../../contexts/SupplierContext";
import UserContext from "../../../../../contexts/UserContext";
import Typeahead from "../../../../shared/Typeahead/Typeahead";
import ICatalogGetUomSetsDTO from "../../../../../models/DTO/ICatalogGetUomSetsDTO";
import EndpointsEnum from "../../../../../models/EndpointsEnum";
import ICatalogOnGetUomSetsDTO from "../../../../../models/DTO/ICatalogOnGetUomSetsDTO";
import IUnit_Of_Measurement_Set from "../../../../../models/IUnit_Of_Measurement_Set";
import IUiSocketSetup from "../../../../../models/IUiSocketSetup";
import OwSelectOption from "../../../../shared/OwSelectOption/OwSelectOption";

type Props = {
    setUomSet: (set: IUnit_Of_Measurement_Set | null) => void;
    setPurchaseBaseUnitId?: (id: number | null) => void;
    baseUnit?: IUnit_Of_Measurement_Set;
    purchaseBaseUnitId?: number | null;
};

export const UomSetCatalogItem = (props: Props) => {
    const socketModel = useContext(SocketContext);
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);

    const [lookupItems, setLookupItems] = useState<IUnit_Of_Measurement_Set[]>([]);
    const [selectedSet, setSelectedSet] = useState<IUnit_Of_Measurement_Set | null>(props.baseUnit || null);
    const [clearTypeahead, setClearTypeahead] = useState<boolean>(false);

    const lookupUomSets = (name: string) => {
        const payload: ICatalogGetUomSetsDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            name,
        };

        socketModel?.emit(EndpointsEnum.CatalogsGetUomSets, payload);
    };

    const onGetUomSets = (data: ICatalogOnGetUomSetsDTO) => {
        setLookupItems(data.uomSets);
    };

    const sockets: IUiSocketSetup[] = [{ endpoint: EndpointsEnum.CatalogsOnGetUomSets, fn: onGetUomSets }];

    useEffect(() => {
        props.setUomSet(selectedSet);
    }, [selectedSet]);

    useEffect(() => {
        for (const socket of sockets) {
            socketModel?.on(socket.endpoint, socket.fn);
        }

        return () => {
            for (const socket of sockets) {
                socketModel?.removeListener(socket.endpoint, socket.fn);
            }
        };
    }, []);

    const selectUomSet = (set: IUnit_Of_Measurement_Set) => {
        setSelectedSet(set);
    };

    const clearTypeaheadCallback = () => {
        setSelectedSet(null);
        setClearTypeahead(false);
    };

    const getAvailableOptions = () => {
        const relatedUnits = selectedSet?.Related_Units || props.baseUnit?.Related_Units || [];
        const baseUnit = selectedSet?.Base_Unit || props.baseUnit || {};

        return [baseUnit, ...relatedUnits];
    };

    const setPurchasingBaseUnitId = (e: ChangeEvent<any>) => {
        const value = e.target.value;

        if (props.setPurchaseBaseUnitId) {
            props.setPurchaseBaseUnitId(value);
        }
    };

    return (
        <div className={"UomSetCatalogItem"}>
            <div>
                <OwLabel title={"uom_set"} leftIconClass={"fad fa-cart-flatbed-boxes"} />
            </div>
            <div>
                <Typeahead
                    isSelectableFn={() => true}
                    typeaheadApiFn={lookupUomSets}
                    titleProp={"unit_name"}
                    selectedItemFn={selectUomSet}
                    subTitleProp={"unit_abbr"}
                    selectedItem={selectedSet}
                    selectedItemTitleProp={"unit_name"}
                    scrollableList={true}
                    typeaheadItems={lookupItems}
                    clearTypeaheadCallback={clearTypeaheadCallback}
                    clearTypeahead={clearTypeahead}
                />
            </div>
            <div className="mt-2">
                <div>
                    <OwLabel title={"purchasing_base_unit"} />
                </div>
                <div>
                    <OwSelectOption
                        fn={setPurchasingBaseUnitId}
                        titleProp={"unit_name"}
                        valueProp={"id"}
                        name={"purchase_base_unit_id"}
                        options={getAvailableOptions()}
                        selectedOption={props.purchaseBaseUnitId}
                        hasSelectedOptionProp={false}
                    />
                </div>
            </div>
        </div>
    );
};
